import { useMst } from '../models/rootModel';
import { ErrorType, recordError } from '../models/apiWrappers/api/exceptions';
import { getIpInfo } from '../utils/ip';

export const useUserLocation = async () => {
  const { UserDiscoveryResponse } = useMst();

  try {
    const ipInfo = await getIpInfo();

    if ('ip' in ipInfo) {
      UserDiscoveryResponse.setUserIp(ipInfo.ip);
    }
    if ('country' in ipInfo) {
      UserDiscoveryResponse.setUserCountry(ipInfo.country);
    }
    if ('region' in ipInfo) {
      UserDiscoveryResponse.setUserRegion(ipInfo.region);
    }
    if ('city' in ipInfo) {
      UserDiscoveryResponse.setUserCity(ipInfo.city);
    }
  } catch (err) {
    recordError(ErrorType.API, 'useUserLocation', { err });
  }
};
